import React, { Component } from 'react';
import $j from 'jquery';

import MoveList from '../../../../../../components/MoveList';
import { moveBlock } from './helper';

const diffWidthVariants = ['full'];

const isAWistiaVideo = blockItem => {
  if (blockItem.items[0].media.video && blockItem.items[0].media.video.src.includes('wistiaId:')) {
    return true;
  }
  return false;
};

const getContainerClass = variant => {
  switch (variant) {
    case 'full':
    case 'fullBackground':
    case 'fullCImpact':
    case 'fullDImpact':
    case 'textOverlay':
    case 'quoteD':
      return 'full-blockContainer';
    case 'flashcardGrid':
    case 'flashcardStack':
    case 'accordion':
    case 'tabs':
      return 'blockContainer blockContaier__full-width';
    default:
      return 'blockContainer';
  }
};

const editClicked = (blockItemType, blockItem, openSettings) => () => {
  openSettings({
    openSettings: true,
    blockItem
  });
};

const renderBlockControls = (blockItemType, blockItem, openSettings, hideEditButton) => (
  <div className="block-controls">
    <div className="block-controls__container">
      <div className="block-controls__bar">
        <div className="block-controls__config">
          {false && !hideEditButton && (
            <button
              className="button button--default button--controls"
              onClick={editClicked(blockItemType, blockItem, openSettings)}
            >
              Edit
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
);

const deleteBlock = (blockItem, dispatch) => () => {
  dispatch('REMOVE_BLOCK_ITEM', blockItem);
};

const renderBlockControls2 = (
  blockItemType,
  blockItem,
  openSettings,
  hideEditButton,
  dispatch,
  index,
  blocksLength
) => (
  <div className="blockControls">
    <MoveList
      position={index}
      listLength={blocksLength}
      onPressUp={moveBlock(index, index - 1, dispatch)}
      onPressDown={moveBlock(index, index + 1, dispatch)}
      onPressDelete={deleteBlock(blockItem, dispatch)}
      onPressEdit={editClicked(blockItemType, blockItem, openSettings)}
      disabledEdit={!!hideEditButton}
    />
  </div>
);

export default class WrapperComponent extends Component {
  componentDidMount() {
    this.updateBlockDataForPerformance(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cardId !== this.props.cardId) {
      this.updateBlockDataForPerformance(this.props);
    }
  }

  getChildrenWithProps = children => {
    if (this.props.blockItem.variant === 'video') {
      return React.cloneElement(children, {
        updateVideoData: this.updateVideoData
      });
    }
    return children;
  };

  updateBlockDataForPerformance = props => {
    if (
      !props.editable &&
      props.completionType === 'SCROLL_BASED' &&
      (props.blockItem.variant !== 'video' || !isAWistiaVideo(props.blockItem))
    ) {
      let wordsLength = 2;
      if (props.blockItem.variant === 'video') {
        wordsLength = 10;
      } else {
        wordsLength = $j('.block-' + props.blockItem.pid)
          .text()
          .split(/[\s\n]/).length;
      }
      props.updateBlockDataForPerformance({
        pid: props.blockItem.pid,
        type: 'text',
        variant: props.blockItem.variant,
        wordsLength,
        length: wordsLength / 3
      });
    }
  };

  updateVideoData = ({ videoLength, videoWatchedLength }) => {
    if (this.props.completionType === 'SCROLL_BASED') {
      this.props.updateBlockDataForPerformance({
        pid: this.props.blockItem.pid,
        type: 'video',
        variant: this.props.blockItem.variant,
        length: videoLength,
        videoLength,
        videoWatchedLength
      });
    }
  };

  render() {
    const {
      editable,
      blockItem,
      blockItemType,
      children,
      openSettings,
      hideEditButton,
      hideControls,
      openAddMenu,
      dispatch,
      index,
      blocksLength,
      initialBlock
    } = this.props;
    const containerClass = getContainerClass(blockItem.variant);

    if (editable) {
      return (
        <div
          className={
            'block block--mounted ' +
            'type_' +
            blockItemType +
            ' ' +
            (!!initialBlock && 'initialBlock')
          }
        >
          <div className="block__wrap">
            <div className="block__content">
              {renderBlockControls(blockItemType, blockItem, openSettings, hideEditButton)}
              {!hideControls &&
                renderBlockControls2(
                  blockItemType,
                  blockItem,
                  openSettings,
                  hideEditButton,
                  dispatch,
                  index,
                  blocksLength
                )}
              <div className={containerClass || 'blockContainer'}>{children}</div>
              <div className="block-create" onClick={openAddMenu} role="presentation">
                <button className="block-create__button">+</button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div
        className={
          (containerClass || 'blockContainer') +
          ' type_' +
          blockItemType +
          ' ' +
          ' block-' +
          blockItem.pid
        }
      >
        {this.getChildrenWithProps(children)}
      </div>
    );
  }
}
